import React from 'react';
import styled from 'styled-components';
import { GridCol, GridRow } from '@naf/grid';
import { CardSize, CardNavigation } from '@naf/cards';
import { Text, TextVariant } from '@naf/text';
import { NavCardLink } from '../../styled-link/StyledLink';
import useSelector from '../../../redux/typedHooks';
import { isInternalLink } from '../../../lib/isInternalLink';
import { ShortCutCol } from '../../entry-cards/Styles';
import {
  OtherInformationBlockType,
  OtherInformationType,
  OtherInformationTypeExternal,
  OtherInformationTypeInternal,
} from '../../../../../types/OtherInformationBlockType';

export const OtherInformationBlock = ({ block }: { block: OtherInformationBlockType }) => {
  const baseUrl = useSelector((state) => state.application.baseUrl);
  const { otherInformation } = block;

  if (!otherInformation || otherInformation.length === 0) {
    return null;
  }

  return (
    <SectionCol s="12" m="12" l="12" xl="12">
      <Text variant={TextVariant.Header2}>Annen nyttig informasjon</Text>
      <GridRow>
        {otherInformation.map((card: OtherInformationType) => {
          if (card.type === 'internalLink') {
            return (
              <ShortCutCol s="12" m="6" l="4" xl="4" key={card.key}>
                <NavCardLink to={`${(card.data as OtherInformationTypeInternal).slug}`}>
                  <StyledCardNavigation
                    isInternalLink
                    title={(card.data as OtherInformationTypeInternal).name || ''}
                    size={CardSize.Medium}
                    height="100%"
                  />
                </NavCardLink>
              </ShortCutCol>
            );
          }
          const { isInternal, relativeLink } = isInternalLink(
            baseUrl,
            (card.data as OtherInformationTypeExternal).href,
          );
          if (isInternal) {
            return (
              <ShortCutCol s="12" m="6" l="4" xl="4" key={card.key}>
                <NavCardLink to={relativeLink}>
                  <StyledCardNavigation
                    isInternalLink
                    title={(card.data as OtherInformationTypeExternal).title || ''}
                    size={CardSize.Medium}
                    height="100%"
                  />
                </NavCardLink>
              </ShortCutCol>
            );
          }
          return (
            <ShortCutCol s="12" m="6" l="4" xl="4" key={card.key}>
              <ExternalLink href={`${(card.data as OtherInformationTypeExternal).href}`}>
                <StyledCardNavigation
                  isInternalLink
                  title={(card.data as OtherInformationTypeExternal).title || ''}
                  size={CardSize.Medium}
                  height="100%"
                />
              </ExternalLink>
            </ShortCutCol>
          );
        })}
      </GridRow>
    </SectionCol>
  );
};

const SectionCol = styled(GridCol)`
  display: flex;
  flex-direction: column;
`;

const StyledCardNavigation = styled(CardNavigation)`
  width: 100%;
`;

const ExternalLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
`;
